module.exports = __webpack_public_path__ + "img/pencil.d3a2ea10.svg";